import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FilteringService } from '@shared/modules/filtering/services/filtering.service';
import { pairwise } from 'rxjs/operators';
import { DateInterval } from '@shared/classes/DateInterval';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CardFilteringBaseComponent } from '@shared/modules/filtering/components/card-filtering-base/card-filtering-base.component';

@UntilDestroy()
@Component({
  selector: 'app-date-filtering',
  templateUrl: './date-filtering.component.html',
  styleUrls: ['./date-filtering.component.scss'],
})
export class DateFilteringComponent
  extends CardFilteringBaseComponent
  implements OnInit, OnDestroy {
  dateIntervalPicker = new FormGroup({
    start: new FormControl('', [Validators.required]),
    end: new FormControl('', [Validators.required]),
  });

  constructor(readonly eRef: ElementRef, readonly filteringService: FilteringService) {
    super(eRef, filteringService);
  }

  get tagValue() {
    return `${this.dateIntervalPicker.get('start').value} - ${
      this.dateIntervalPicker.get('end').value
    }`;
  }

  ngOnInit() {
    this.listenSavedFilterChange(this.filterKey);
    this.listenDatePickerValueChange();
    this.listenFilterResetAction()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.resetFormControls();
      });
    this.listenSavedFilterChange(this.filterKey)
      .pipe(untilDestroyed(this))
      .subscribe((items: DateInterval | undefined) => {
        this.setValueForControls(items);
      });
    return super.ngOnInit();
  }

  ngOnDestroy() {
    this.resetFormControls();
    return super.ngOnDestroy();
  }

  onCheckboxChanged(isChecked: boolean) {
    this.isChecked = isChecked;
    this.isOpen = false;
    if (isChecked) {
      this.filterValueChange.emit({ [this.filterKey]: this.dateIntervalPicker.getRawValue() });
    } else {
      this.filterValueChange.emit({ [this.filterKey]: undefined });
    }
  }

  deleteItem() {
    this.resetFormControls();
  }

  private listenDatePickerValueChange(): void {
    this.dateIntervalPicker.valueChanges
      .pipe(pairwise(), untilDestroyed(this))
      .subscribe(([, next]: [DateInterval, DateInterval]) => {
        if (!(next.start && next.end)) {
          this.isOpen = true;
        }
        if (this.dateIntervalPicker.valid) {
          this.isDisabled = false;
          this.isChecked = true;
          this.filterValueChange.emit({ [this.filterKey]: this.dateIntervalPicker.getRawValue() });
        } else {
          this.isDisabled = true;
          this.isChecked = false;
          this.filterValueChange.emit({ [this.filterKey]: undefined });
        }
      });
  }

  private setValueForControls(valueOfControl: DateInterval | undefined): void {
    if (typeof valueOfControl !== 'undefined') {
      this.dateIntervalPicker.patchValue(valueOfControl);
    } else {
      this.resetFormControls();
    }
  }

  private resetFormControls(): void {
    this.dateIntervalPicker.reset();
  }
}
